import { OnboardingLayout } from "Components/Layout/OnboardingLayout";
import { useOnboardingFlow } from "Components/Onboarding/BusinessEntity/Hooks/useOnboardingFlow";
import { useOnboardingResumeStep } from "Components/Onboarding/BusinessEntity/Hooks/useOnboardingResumeStep";
import { OnboardingWizard } from "Components/Onboarding/BusinessEntity/OnboardingWizard";
import { CenteredCircularProgress } from "Components/Shared/CenteredCircularProgress";
import type { PartyType } from "Infrastructure/Api/Api";
import { Resources, useResource } from "Translations/Resources";

type Props = {
  partyType: PartyType;
};

export const BusinessEntityOnboarding = ({ partyType }: Props) => {
  const { t } = useResource();
  const onboardingFlow = useOnboardingFlow(partyType);
  const resumeStep = useOnboardingResumeStep(onboardingFlow);

  if (resumeStep.isLoading) {
    return (
      <OnboardingLayout title={t(Resources.Onboarding.LoadingTitle)}>
        <CenteredCircularProgress />
      </OnboardingLayout>
    );
  }

  return (
    <OnboardingWizard
      flow={onboardingFlow}
      initialStep={resumeStep.initialStep}
    />
  );
};
